import React, { useEffect } from "react";
import MedicalFormCopy from "../Investigation/Report/MedicalForm/MedicalFormCopy";
import { useLocation } from "react-router-dom";
import UserInvoiceCopy from "../Investigation/Invoice/UserInvoiceCopy";

const PrintInvoiceForm = () => {
  const patientData = 1;
  const patientDataInv = 2;

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 2000);
  }, []);

  return (
    <div>
      <UserInvoiceCopy stateData={patientData} />

      <div style={{ pageBreakAfter: "always" }}></div>

      <MedicalFormCopy stateData={patientData} stateDataInv={patientDataInv} />
    </div>
  );
};

export default PrintInvoiceForm;
